import React from "react";
import "./Billing_manegment.css";
import Billing_manegment_card from "./billing_manegment_card/Billing_manegment_card";

function Billing_manegment() {
  const data = [
    {
      invoiceId: "AFINV125475651",
      program: "Bachelor in Management",
      amount: "€800",
      issuedDate: "10 Oct 2025",
      dueDate: "15 Oct 2025",
      status: "Pending",
      paymentMethod: "NA",
      isPaid: false,
    },
    {
      invoiceId: "AFINV125475651",
      program: "Sous Chef",
      amount: "€1200",
      issuedDate: "05 Dec 2025",
      dueDate: "NA",
      status: "Done",
      paymentMethod: "Bank Transfer",
      isPaid: true,
    },
  ];

  return (
    <section className="Billing_manegment">
      <div className="row">
        {data.map((item, index) => (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-3" key={index}>
            <Billing_manegment_card {...item} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Billing_manegment;
